// ISO3 of each country Smarty verifies, mapped to the state code Smarty returns for it (USA has many).
// Imported by the browser bundle, so it must stay free of imports.
export const SMARTY_COUNTRIES = Object.freeze({
  USA: null,
  PRI: "PR",
  GUM: "GU",
  VIR: "VI",
  ASM: "AS",
  MNP: "MP"
});

export function isSmartyCountry(iso3) {
  return (
    typeof iso3 === "string" &&
    Object.prototype.hasOwnProperty.call(SMARTY_COUNTRIES, iso3)
  );
}

export function getTerritoryStateCode(iso3) {
  return isSmartyCountry(iso3) ? SMARTY_COUNTRIES[iso3] : null;
}

export function getSmartyCountryForState(state) {
  return (
    Object.keys(SMARTY_COUNTRIES).find(
      (iso3) => SMARTY_COUNTRIES[iso3] && SMARTY_COUNTRIES[iso3] === state
    ) || "USA"
  );
}
